import React from 'react';

const AuthorizationSection = ({ authorizations }) => (
  <div className="authorization-section">
    <h2>Authorizations</h2>
    {authorizations.map((auth, idx) => (
      <div key={idx} className="authorization-card">
        <p><strong>Authorization ID:</strong> {auth.authId}</p>
        <p><strong>Diagnosis:</strong> {auth.diagnosisName}</p>
        <p><strong>Procedure:</strong> {auth.procedureName}</p>
      </div>
    ))}
  </div>
);

export default AuthorizationSection;
